import myZone from '@/api/serviceProviders/my-zone'
import { AddVerifiableMethodRequest,
    AddVerifiableMethodResponse,
    AnswerChallengeRequest,
    AvailableVerificationMethodsResponse,
    VerificationChallengeSummaryResponse,
    VerificationMethodsResponse,
    RemoveVerifiableMethodRequest,
    RemoveVerifiableMethodResponse,
    UpdateVerifiableMethodRequest,
    UpdateVerifiableMethodResponse } from '@/api/requests/verification/verificationResponses'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL
const JSON_HEADERS = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
}
const USERS_VERIFICATION_PREFIX = API_BASE_URL + '/api/admin/users'

export const getVerifiableMethods = async () => {
    return await myZone.get(USERS_VERIFICATION_PREFIX + '/configured-methods', {
        headers: JSON_HEADERS,
    }) as VerificationMethodsResponse
}

export const addVerifiableMethod = async (payload: AddVerifiableMethodRequest) => {
    return await myZone.post(USERS_VERIFICATION_PREFIX + '/add-verifiable-method', payload, {
        headers: JSON_HEADERS,
    }) as AddVerifiableMethodResponse
}

export const answerVerificationChallenge = async (payload: AnswerChallengeRequest) => {
    return await  myZone.post(USERS_VERIFICATION_PREFIX + '/answer-challenge', payload, {
        headers: JSON_HEADERS,
    }) as VerificationChallengeSummaryResponse
}

export const removeVerifiableMethod = async (payload: RemoveVerifiableMethodRequest) => {
    return await myZone.post(USERS_VERIFICATION_PREFIX + '/remove-verifiable-method', payload, {
        headers: JSON_HEADERS,
    }) as RemoveVerifiableMethodResponse
}

export const updateVerifiableMethod = async (payload: UpdateVerifiableMethodRequest) => {
    return await myZone.post(USERS_VERIFICATION_PREFIX + '/update-verifiable-method', payload, {
        headers: JSON_HEADERS,
    }) as UpdateVerifiableMethodResponse
}

export const getAvailableVerificationMethods = async () => {
    return await myZone.get(USERS_VERIFICATION_PREFIX + '/available-methods', {
        headers: JSON_HEADERS,
    }) as AvailableVerificationMethodsResponse
}
